/* GemiiBeauty storefront PayNow. Order/payment creation remains in Shopify checkout. */
(function () {
  'use strict';
  if (window.GemiiPayNow) return;

  const NUMBER = '80117121';
  const QR = 'https://cdn.estore5s.com/estore/1070/1070_32428_CrTNuXaB.jpg';
  const RECIPIENT = 'CHOW JIA LI';
  let dialog, openedBy, selected, previousOverflow;

  function selection() {
    try {
      if (typeof current === 'undefined' || typeof checkoutReady !== 'function' ||
          typeof commerce === 'undefined' || !checkoutReady(current)) return null;
      return {
        id: current.id, name: current.name, days: current.days,
        price: current.price, variantId: current.variantId, available: current.available
      };
    } catch (_) { return null; }
  }

  function ready(plan) {
    try { return !!plan && checkoutReady(plan); }
    catch (_) { return false; }
  }

  function price(value) {
    return 'S$' + new Intl.NumberFormat('en-SG', { maximumFractionDigits: 2 }).format(value);
  }

  function close() {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }

  function build() {
    const style = document.createElement('style');
    style.id = 'gbPayNowStyles';
    style.textContent = `
      .gb-paynow-trigger{display:flex;align-items:center;justify-content:center;gap:9px;width:100%;min-height:48px;margin:10px 0 0;border:1.5px solid #b71945;border-radius:14px;background:#fff;color:#9d1238;font:inherit;font-size:15px;font-weight:700;line-height:1.25;cursor:pointer;padding:12px 18px}
      .gb-paynow-trigger:disabled{opacity:.5;cursor:not-allowed}
      .gb-paynow-trigger:hover{background:#fff2f3}.gb-paynow-trigger:focus-visible,#gbPayNowModal :focus-visible{outline:3px solid #b71945;outline-offset:3px}
      #gbPayNowModal{box-sizing:border-box;width:min(440px,calc(100vw - 28px));max-height:calc(100dvh - 28px);margin:auto;padding:22px;border:1px solid #f0cbd3;border-radius:22px;background:#fffaf8;color:#42172b;box-shadow:0 24px 80px #280b2840;font-family:inherit;overflow:auto;overscroll-behavior:contain}
      #gbPayNowModal::backdrop{background:#25121bb3;backdrop-filter:blur(3px)}
      #gbPayNowModal .gb-pn-heading{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;margin:0 0 12px}
      #gbPayNowModal h2{margin:0;font:inherit;font-size:25px;font-weight:800;line-height:1.2;letter-spacing:-.5px}
      #gbPayNowModal .gb-pn-close{width:36px;height:36px;flex:0 0 36px;border:0;border-radius:50%;background:#f7e7e8;color:#6d243c;font:400 27px/1 sans-serif;cursor:pointer}
      #gbPayNowModal .gb-pn-plan{display:flex;justify-content:space-between;align-items:start;gap:16px;padding:13px 0;border-top:1px solid #efd7dc;border-bottom:1px solid #efd7dc;font-size:14px;line-height:1.45}
      #gbPayNowModal .gb-pn-plan small{display:block;color:#806771;font-size:12px}
      #gbPayNowModal .gb-pn-price{text-align:right;font-size:21px;font-weight:800;white-space:nowrap}
      #gbPayNowModal .gb-pn-qr{display:block;width:min(236px,100%);height:auto;aspect-ratio:660/665;object-fit:contain;background:#fff;border:1px solid #eee1e5;border-radius:12px;margin:16px auto 10px}
      #gbPayNowModal .gb-pn-recipient{text-align:center;margin:0 0 12px;font-size:13px;line-height:1.5;color:#71545f}
      #gbPayNowModal .gb-pn-recipient strong{color:#42172b}
      #gbPayNowModal .gb-pn-label{display:block;font-size:12px;font-weight:700;margin-bottom:5px;color:#71545f}
      #gbPayNowModal .gb-pn-copyrow{display:flex;gap:8px}
      #gbPayNowModal input{box-sizing:border-box;min-width:0;width:100%;border:1px solid #dfbdc6;border-radius:10px;background:#fff;padding:10px 12px;color:#42172b;font:inherit;font-size:24px;font-weight:700;line-height:1.2;letter-spacing:1px;text-align:left}
      #gbPayNowModal .gb-pn-copy{flex:0 0 106px;border:0;border-radius:10px;padding:10px;background:#a4113b;color:#fff;font:inherit;font-size:14px;font-weight:700;line-height:1.3;cursor:pointer}
      #gbPayNowModal .gb-pn-status{min-height:18px;margin:6px 0 10px;font-size:12px;line-height:1.4;color:#73515e}
      #gbPayNowModal .gb-pn-help{font-size:13px;line-height:1.5;margin:0 0 14px;padding-left:19px;color:#73515e}
      #gbPayNowModal .gb-pn-help li+li{margin-top:4px}
      #gbPayNowModal .gb-pn-next{display:block;padding:14px 16px;border-radius:12px;background:#bb1747;color:#fff;text-align:center;text-decoration:none;font-size:15px;font-weight:800;line-height:1.3}
      #gbPayNowModal .gb-pn-footer{font-size:11px;line-height:1.5;color:#806771;text-align:center;margin:9px 0 0}
      html.gb-paynow-open{overflow:hidden}
      @media(max-width:390px){#gbPayNowModal{padding:18px}#gbPayNowModal h2{font-size:23px}#gbPayNowModal .gb-pn-qr{width:210px}#gbPayNowModal .gb-pn-copy{flex-basis:98px}}
    `;
    document.head.appendChild(style);
    dialog = document.createElement('dialog');
    dialog.id = 'gbPayNowModal';
    dialog.setAttribute('aria-labelledby', 'gbPayNowTitle');
    dialog.innerHTML = `
      <div class="gb-pn-heading"><h2 id="gbPayNowTitle">Pay with PayNow</h2><button class="gb-pn-close" type="button" aria-label="Close PayNow">×</button></div>
      <div class="gb-pn-plan"><div><strong id="gbPayNowPlan"></strong><small id="gbPayNowDays"></small></div><div class="gb-pn-price"><span id="gbPayNowPrice"></span><small>Package price</small></div></div>
      <img class="gb-pn-qr" src="${QR}" alt="PayNow QR code for CHOW JIA LI" width="660" height="665">
      <p class="gb-pn-recipient">PayNow recipient: <strong>${RECIPIENT}</strong></p>
      <label class="gb-pn-label" for="gbPayNowNumber">Singapore mobile number (+65)</label>
      <div class="gb-pn-copyrow"><input id="gbPayNowNumber" type="text" value="${NUMBER}" readonly inputmode="numeric" autocomplete="off" spellcheck="false"><button class="gb-pn-copy" type="button">Copy number</button></div>
      <p class="gb-pn-status" id="gbPayNowCopyStatus" role="status" aria-live="polite"></p>
      <ol class="gb-pn-help"><li>Continue to checkout and choose <strong>PayNow (SG)</strong>.</li><li>Place your order, then transfer the final order total using your order number.</li><li>Upload your receipt on the confirmation page.</li></ol>
      <a class="gb-pn-next" id="gbPayNowCheckout" href="#">Continue to checkout →</a>
      <p class="gb-pn-footer">Your order is paid only after the transfer is confirmed.</p>
    `;
    document.body.appendChild(dialog);
    dialog.querySelector('.gb-pn-close').addEventListener('click', close);
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('gb-paynow-open');
      document.documentElement.style.overflow = previousOverflow || '';
      if (openedBy && openedBy.isConnected) openedBy.focus({ preventScroll: true });
      selected = null;
    });
    dialog.querySelector('.gb-pn-qr').addEventListener('error', function () {
      dialog.querySelector('.gb-pn-status').textContent = 'QR unavailable. You can still use the PayNow number below.';
    });
    dialog.querySelector('#gbPayNowNumber').addEventListener('click', function () { this.select(); });
    dialog.querySelector('.gb-pn-copy').addEventListener('click', async function () {
      const field = dialog.querySelector('#gbPayNowNumber');
      const status = dialog.querySelector('#gbPayNowCopyStatus');
      let copied = false;
      status.textContent = 'Copying…';
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await Promise.race([
            navigator.clipboard.writeText(NUMBER),
            new Promise(function (_, reject) { setTimeout(function () { reject(new Error('Copy timed out')); }, 1500); })
          ]);
          copied = true;
        } catch (_) { /* Fall back to copying the visible number. */ }
      }
      if (!copied) {
        field.focus({ preventScroll: true });
        field.select();
        try { copied = document.execCommand('copy'); } catch (_) { copied = false; }
      }
      status.textContent = copied ? 'Copied 80117121' : 'Select and hold 80117121 above, then tap Copy.';
    });
    dialog.querySelector('#gbPayNowCheckout').addEventListener('click', function (event) {
      if (ready(selected)) return;
      event.preventDefault();
      dialog.querySelector('#gbPayNowCopyStatus').textContent = 'This plan is unavailable. Close this window and choose another plan.';
    });
  }

  function open(trigger) {
    if (dialog && dialog.open) return true;
    const plan = selection();
    if (!plan) return false;
    if (!dialog) build();
    selected = plan;
    openedBy = trigger;
    dialog.querySelector('#gbPayNowPlan').textContent = plan.name;
    dialog.querySelector('#gbPayNowDays').textContent = plan.days + ' days';
    dialog.querySelector('#gbPayNowPrice').textContent = price(plan.price);
    dialog.querySelector('#gbPayNowCopyStatus').textContent = '';
    dialog.querySelector('#gbPayNowCheckout').href = (commerce.cartUrl || '/cart').replace(/\/$/, '') + '/' + plan.variantId + ':1';
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.classList.add('gb-paynow-open');
    dialog.showModal();
    dialog.querySelector('.gb-pn-close').focus({ preventScroll: true });
    return true;
  }

  function init() {
    if (!('HTMLDialogElement' in window) || typeof checkoutReady !== 'function' || typeof commerce === 'undefined') return;
    document.querySelectorAll('.buy-box .js-buy').forEach(function (buy) {
      if (buy.parentElement.querySelector('.gb-paynow-trigger')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'gb-paynow-trigger';
      button.textContent = 'PayNow · View QR';
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', 'gbPayNowModal');
      button.disabled = !selection();
      button.addEventListener('click', function () { open(button); });
      buy.insertAdjacentElement('afterend', button);
      new MutationObserver(function () { button.disabled = !selection(); }).observe(buy, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    });
    window.addEventListener('pagehide', close);
  }

  window.GemiiPayNow = { version: '2026-10-25.3' };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

;
/* Optional classic-script addon: prepare a receipt for the selected native checkout only. */
(function () {
  'use strict';
  if (window.GemiiHomeCheckoutHandoff) return;
  window.GemiiHomeCheckoutHandoff = Object.freeze({ version: '2026-10-27.2' });

  const WORKER = 'https://gemiibeauty-store.shunfun94.workers.dev';
  const KEY = 'gemii:homeReceipt';
  const LEGACY = Object.freeze({
    '49853542662299': { sku: 'GB-NI-BASIC', quantity: 1 },
    '49853542695067': { sku: 'GB-NI-REGULATING', quantity: 2 },
    '49853542727835': { sku: 'GB-NI-CONFIDENCE', quantity: 3 },
    '49853542760603': { sku: 'GB-NI-PERFECT', quantity: 6 }
  });
  const HOME = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(location.pathname);
  const GENERAL = /\/pages\/double11general\/?$/i.test(location.pathname);
  const fail = message => { throw Object.assign(new Error(message), { checkoutMessage: true }); };
  let active = null;

  function clearHomeReceipt() {
    try { sessionStorage.removeItem(KEY); }
    catch { /* Optional receipt storage must not block native Shopify checkout. */ }
  }
  if (HOME || GENERAL) clearHomeReceipt();
  window.addEventListener('pageshow', event => {
    if (event.persisted && !active && (HOME || GENERAL)) clearHomeReceipt();
  });
  if (!HOME) return;

  function supported() {
    const shop = window.GB_SHOPIFY;
    return location.protocol === 'https:' && ['gemiibeauty.com', 'www.gemiibeauty.com'].includes(location.hostname) &&
      shop?.preview === false && shop.checkoutEnabled === true && shop.currency === 'SGD' && shop.shopCurrency === 'SGD';
  }
  function cents(value) {
    if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0) return null;
    const result = Math.round(value * 100);
    return Number.isSafeInteger(result) && result / 100 === value ? result : null;
  }
  function displayedCents(node) {
    const match = /^S\$\s*((?:\d{1,3}(?:,\d{3})+|\d+))(?:\.(\d{1,2}))?$/.exec(node?.textContent?.trim() || '');
    if (!match) fail('Your displayed price could not be confirmed. Refresh the page and choose your selection again.');
    const value = Number(match[1].replace(/,/g, '')) * 100 + Number((match[2] || '').padEnd(2, '0'));
    if (!Number.isSafeInteger(value) || value <= 0) fail('Your displayed price could not be confirmed. Refresh the page and try again.');
    return value;
  }
  function identity(items) {
    if (!Array.isArray(items) || !items.length || items.length > 2) return null;
    const seen = new Set();
    const rows = [];
    for (const item of items) {
      if (!item || !['novia', 'isoduce'].includes(item.id) || seen.has(item.id) || !Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 6) return null;
      seen.add(item.id);
      rows.push(item.id + ':' + item.quantity);
    }
    return rows.sort().join('|');
  }
  function cartBase() {
    const url = new URL(window.GB_SHOPIFY?.cartUrl || '/cart', location.origin);
    if (url.origin !== location.origin || url.search || url.hash || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(url.pathname)) {
      fail('The checkout link could not be confirmed. Refresh the page and try again.');
    }
    return url.pathname.replace(/\/$/, '');
  }
  function readSelection(control, root, kind) {
    if (!supported() || !root.open) fail('Close this window, refresh the Singapore store and choose your selection again.');
    let items, sku, variantId = null, handle, price;
    const base = cartBase();
    if (kind === 'mix') {
      const counts = ['novia', 'isoduce'].map(id => {
        const text = root.querySelector('#gb-md-' + id)?.textContent?.trim() || '';
        if (!/^[0-6]$/.test(text)) fail('Please review the quantities in your selection and try again.');
        return Number(text);
      });
      if (!counts[0] && !counts[1]) fail('Choose at least one product before continuing.');
      items = counts.flatMap((quantity, index) => quantity ? [{ id: ['novia', 'isoduce'][index], quantity }] : []);
      sku = 'GB-NI-MIX1111-N' + counts[0] + '-I' + counts[1];
      handle = 'novia-isoduce-plus-mix-1111';
      price = displayedCents(root.querySelector('#gb-md-total'));
    } else {
      const href = new URL(control.getAttribute('href') || '', location.origin);
      const prefix = base + '/';
      const match = href.pathname.startsWith(prefix) && /^(\d+):1$/.exec(href.pathname.slice(prefix.length));
      if (href.origin !== location.origin || href.search || href.hash || !match || !Object.hasOwn(LEGACY, match[1])) {
        fail('This checkout link has changed. Close this window and choose your plan again.');
      }
      variantId = match[1];
      const plan = LEGACY[variantId];
      // The existing homepage uses global lexical bindings, rather than window.current.
      try {
        if (typeof current !== 'undefined' && (!current || String(current.variantId) !== variantId ||
          typeof checkoutReady !== 'function' || !checkoutReady(current))) {
          fail('Your selected plan has changed. Close this window and choose your plan again.');
        }
      } catch (error) {
        if (error.checkoutMessage) throw error;
        fail('Your selected plan could not be confirmed. Close this window and choose your plan again.');
      }
      items = [{ id: 'novia', quantity: plan.quantity }, { id: 'isoduce', quantity: plan.quantity }];
      sku = plan.sku;
      handle = 'novia-isoduce-plus';
      price = displayedCents(root.querySelector('#gbPayNowPrice'));
    }
    return { items, fingerprint: identity(items), sku, variantId, handle, displayedCents: price, base };
  }
  function statusNode(root, control, kind) {
    let status = root.querySelector(kind === 'mix' ? '.gb-md-status' : '#gb-home-receipt-status');
    if (!status) {
      status = document.createElement('p');
      if (kind === 'mix') status.className = 'gb-md-status';
      else status.id = 'gb-home-receipt-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.style.cssText = 'font-size:13px;line-height:1.5;color:#73515e;margin:10px 0;';
      control.before(status);
    }
    return status;
  }
  function setStatus(context, text) { if (context.status) context.status.textContent = text; }
  function restore(context) {
    if (context.restored) return;
    context.restored = true;
    clearTimeout(context.timer);
    context.root.removeEventListener('close', context.onClose);
    for (const [name, value] of context.attributes) {
      if (value === null) context.control.removeAttribute(name);
      else context.control.setAttribute(name, value);
    }
    if (active === context) active = null;
  }
  function checkCurrent(context) {
    if (active !== context || context.controller.signal.aborted || !context.root.open) throw new DOMException('Checkout preparation cancelled', 'AbortError');
    const now = readSelection(context.control, context.root, context.kind);
    if (now.fingerprint !== context.selection.fingerprint || now.displayedCents !== context.selection.displayedCents || now.variantId !== context.selection.variantId || now.base !== context.selection.base) {
      fail('Your selection changed while it was being checked. Review it and select Continue again.');
    }
  }
  async function json(url, options, context) {
    const response = await fetch(url, { cache: 'no-store', redirect: 'error', ...options, signal: context.controller.signal });
    if (!response.ok) fail('We could not prepare checkout. Please select Continue again to retry.');
    const result = await response.json();
    checkCurrent(context);
    return result;
  }
  async function optionalReceipt(context, variant) {
    const selected = context.selection;
    const controller = new AbortController();
    let timer, unavailable;
    const timeout = new Promise(resolve => {
      unavailable = () => { controller.abort(); resolve(null); };
      timer = setTimeout(unavailable, 2500);
    });
    context.controller.signal.addEventListener('abort', unavailable, { once: true });
    try {
      const request = (async () => {
        try {
          const response = await fetch(WORKER + '/api/receipt-intake/start', {
            method: 'POST', credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store', redirect: 'error',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: selected.items }), signal: controller.signal
          });
          return response.ok ? await response.json() : null;
        } catch { return null; }
      })();
      const receipt = await Promise.race([request, timeout]);
      checkCurrent(context);
      const quote = receipt?.quote;
      if (!quote || typeof quote !== 'object' || Array.isArray(quote)) return null;
      // A returned quote that contradicts the selected native offer is a blocking discrepancy.
      if (quote.currency !== 'SGD' || identity(quote.items) !== selected.fingerprint || cents(quote.total) !== variant.price) {
        fail('Your checkout total could not be confirmed. Refresh the page and review your selection before continuing.');
      }
      if (!/^[a-f0-9]{64}$/.test(receipt.capability || '') || !/^RI[A-F0-9]{20}$/.test(receipt.reference || '')) return null;
      const record = JSON.stringify({ ref: receipt.capability, createdAt: Date.now(), fingerprint: selected.fingerprint, totalCents: variant.price, source: 'homepage', variantId: variant.id });
      try {
        sessionStorage.setItem(KEY, record);
        if (sessionStorage.getItem(KEY) !== record) throw new Error('Storage check failed');
      } catch {
        clearHomeReceipt();
        return null;
      }
      return receipt.reference;
    } finally {
      clearTimeout(timer);
      context.controller.signal.removeEventListener('abort', unavailable);
      controller.abort();
    }
  }
  async function prepare(control, root, kind) {
    if (active) return;
    const context = {
      control, root, kind, status: statusNode(root, control, kind), controller: new AbortController(),
      attributes: ['aria-busy', 'aria-disabled'].map(name => [name, control.getAttribute(name)])
    };
    active = context;
    context.onClose = () => { context.controller.abort(); restore(context); };
    root.addEventListener('close', context.onClose, { once: true });
    context.timer = setTimeout(() => context.controller.abort(), 20000);
    control.setAttribute('aria-busy', 'true');
    control.setAttribute('aria-disabled', 'true');
    setStatus(context, 'Confirming your selection and preparing checkout…');
    try {
      clearHomeReceipt();
      context.selection = readSelection(control, root, kind);
      const selected = context.selection;
      const product = await json('/products/' + selected.handle + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }, context);
      if (product?.handle !== selected.handle || product.requires_selling_plan || (product.selling_plan_groups != null && (!Array.isArray(product.selling_plan_groups) || product.selling_plan_groups.length)) || !Array.isArray(product.variants)) {
        fail('This selection is not available as a one-time purchase. Please choose your selection again.');
      }
      const matching = product.variants.filter(variant => variant?.sku === selected.sku);
      const variant = matching[0];
      if (matching.length !== 1 || !variant || variant.available !== true || variant.requires_selling_plan || !Number.isSafeInteger(variant.id) || variant.id <= 0 || !Number.isSafeInteger(variant.price) || variant.price <= 0 || (selected.variantId && String(variant.id) !== selected.variantId)) {
        fail('This selection is unavailable. Please close this window and choose your selection again.');
      }
      if (variant.price !== selected.displayedCents) fail('The price has changed. Refresh the page and review your selection before continuing.');
      clearTimeout(context.timer);
      const receiptReference = await optionalReceipt(context, variant);
      checkCurrent(context);
      const target = new URL(selected.base + '/' + variant.id + ':1', location.origin);
      if (kind === 'mix') {
        const counts = Object.fromEntries(selected.items.map(item => [item.id, item.quantity]));
        target.searchParams.set('note', 'NOVIA: ' + (counts.novia || 0) + ' boxes\nISODUCE PLUS: ' + (counts.isoduce || 0) + ' boxes');
      }
      if (receiptReference) {
        target.searchParams.set('attributes[gemii_receipt_ref]', receiptReference);
        setStatus(context, 'Selection confirmed. Opening secure checkout…');
      } else {
        clearHomeReceipt();
        setStatus(context, 'Opening Shopify checkout. Receipt upload can be arranged with Gemi.');
      }
      location.assign(target.href);
    } catch (error) {
      if (active === context) {
        clearHomeReceipt();
        if (root.open) setStatus(context, error.name === 'AbortError' ? 'Checkout preparation took too long. Select Continue again to retry.' : error.checkoutMessage ? error.message : 'We could not prepare checkout. Check your connection and select Continue again to retry.');
      }
    } finally {
      restore(context);
    }
  }
  document.addEventListener('click', event => {
    const target = event.target?.closest ? event.target : event.target?.parentElement;
    const control = target?.closest('#gb-mix-drawer .gb-md-pay, #gbPayNowCheckout');
    if (!control) return;
    const kind = control.id === 'gbPayNowCheckout' ? 'legacy' : 'mix';
    const root = control.closest(kind === 'mix' ? '#gb-mix-drawer' : '#gbPayNowModal');
    if (!root) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void prepare(control, root, kind);
  }, true);
  window.addEventListener('pagehide', () => {
    if (active) { active.controller.abort(); restore(active); }
  });
})();
